// Chart catalog for the project dashboard (Stream V1). Kept out of
// DashboardPage.tsx so the component file only exports components (the
// route also imports these to validate the `?hide` URL state).

export const DASHBOARD_CHARTS = [
  { id: 'shot-status', title: 'Shot status' },
  { id: 'shots-per-scene', title: 'Shots per scene' },
  { id: 'tasks-by-type', title: 'Tasks by type' },
  { id: 'track-split', title: 'AI vs traditional' },
  { id: 'compliance', title: 'Compliance signing' },
] as const;

export type ChartId = (typeof DASHBOARD_CHARTS)[number]['id'];
